import { ITenantEnvironmentConfigResponse } from '../../tenants-api';

/**
 * This `id` property to fallback to `global` if the identifier is empty.
 */
export function formatTenantList(
  tenantConfig: ITenantEnvironmentConfigResponse
): ITenantEnvironmentConfigResponse {
  const { environments, languages } = tenantConfig || {};

  const formattedEnvironments = environments.map((env) => {
    const { identifier } = env;
    return {
      ...env,
      // TODO: Remove this later once fully tested.
      // id: identifier.length > 0 ? identifier : 'global',
      id: identifier || 'global',
    };
  });

  return {
    environments: formattedEnvironments,
    languages,
  };
}
